<template lang="pug">

  section.descarga
    .descarga-item(v-if="!documents || !documents.length")
      .key En breve aquí encontrará los documentos para su descarga
    md-list
      template(v-for="document in data")
        md-list-item.descarga-item
          .key(v-html="document.name")
          .value
            DownloadButton(:href="document.link" :type="document.type" :color="color")
        md-divider

</template>

<script>
import colorPropertyMixin from '@/mixins/color-property.js'

export default {
  name: 'DownloadPanel',
  mixins: [colorPropertyMixin],
  props: {
    baseUrl: String,
    code: {
      type: String,
      default: ''
    },
    documents: Array
  },
  data () {
    return {
      data: []
    }
  },
  watch: {
    documents () {
      this.mapDocuments()
    }
  },
  mounted () {
    this.mapDocuments()
  },
  methods: {
    mapDocuments () {
      if (!this.documents) {
        return
      }
      this.data = this.documents.map(document => {
        const d = typeof document === 'string' ? { name: document, link: document } : document

        const name = d.name || d
        let link = d.link || d.name || d

        let type = 'download'
        if (d.link && d.link.indexOf('youtube') >= 0) type = 'youtube'
        else if (d.link && d.link.indexOf('http') === 0) type = 'link'
        else link = `${this.baseUrl}${this.code}/${link}`

        return {
          type,
          name,
          link
        }
      })
    },
    getDocumentName (document) {
      return (document && document.name) || document
    },
    getDocumentUrl (document) {
      let url = this.baseUrl || ''
      url += this.code + '/' || ''
      url += document && (document.name || document)
      return url
    },
    getLinkUrl (document) {
      return document && document.link
    },
    getYoutubeUrl (document) {
      return document && document.youtube
    },
    hasLink (document) {
      return document.link && typeof document.link === 'string'
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~@/styles/variables'

  $download-button-size = 2rem

  .descarga
    padding-left: $f5px
    padding-right: $f5px
    .md-list-item.descarga-item
      margin-top: $f15px
      &:first-child
        margin-top: 0
      & >>> .md-button-clean
        white-space: normal
      & >>> .md-list-item-content.md-ripple
        .key
          font: bold 1.2rem 'Roboto'
          color: $gray
          width: "calc(100% - %s)" % ($download-button-size * 1.5)
</style>
